<mat-toolbar>
    <app-create-home-icon></app-create-home-icon>
</mat-toolbar>
<app-show-rule-tree [temp]="rulesDoc" [selectedRule]="selectedRule">

</app-show-rule-tree>